// extracted by mini-css-extract-plugin
export default {"benefitTooltip":"uplifter-benefits_benefitTooltip__ip1lC","buttonRow":"uplifter-benefits_buttonRow__mX8dn","uplifterListItem":"uplifter-benefits_uplifterListItem__iQwew"};